<section class="FilterSlider"
	*ngIf="filterService[collection].length > 0"
	[ngClass]="'FilterSlider--' + collection"
	[id]="'filterSlider_' + collection"
>
	<div class="uk-position-relative" uk-slider="finite: true">
		<div class="uk-slider-container">
			<ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-4@s uk-child-width-1-5@m uk-child-width-1-6@l">
				<li *ngFor="let item of filterService[collection]">
					<div class="FilterSlider_Slide"
						(click)="filterService.setActiveFilter(item, (collection === 'targetAudiences' ? 'target' : 'activity'))">
			            <div class="FilterSlider_Slide_Icon"
							[ngClass]="'FilterSlider_Slide_Icon--' + modifier"
							[class.FilterSlider_Slide_Icon--no-active]="showItem(item)"
							[style.background-image]="item.image && item.image.thumbnail ? 'url('+item.image.thumbnail.uri+')' : item.image ? 'url('+item.image.file.uri+')' : ''">
						</div>
			            <div class="FilterSlider_Slide_Title uk-text-center">{{item.name}}</div>
			        </div>
				</li>
			</ul>
		</div>

		<a class="SliderArrow SliderArrow--left uk-position-top-left" href="#" uk-slider-item="previous">
			<span class="IconItem IconItem--arrowLeft">
				<img src="/assets/img/icon/arrow-left.svg" uk-svg>
			</span>
		</a>

		<a class="SliderArrow SliderArrow--right uk-position-top-right" href="#" uk-slider-item="next">
			<span class="IconItem IconItem--arrowRight">
				<img src="/assets/img/icon/arrow-right.svg" uk-svg>
			</span>
		</a>
	</div>
</section>
